module.exports = __webpack_public_path__ + "assets/img/informationDate_first.e005901f.svg";